import React from "react";

const Product = props => {
  return <h1>Welcome to product!</h1>
}

export default Product;